import { NewsEventType } from '@finance-lab/utils/types'
import React from 'react'
import { useTranslation } from 'react-i18next'

function NewsHeadlineProspectusMemorandum({ row }: { row: { companyName: string; eventType: NewsEventType } }) {
    const { t } = useTranslation()
    const { companyName, eventType } = row

    const documentType =
        eventType === 'prospectus'
            ? t('pages.news.headlines.prospectus.prospectus')
            : eventType === 'informationdocument'
              ? t('pages.news.headlines.prospectus.informationDocument')
              : eventType

    return (
        <span>
            {t('pages.news.headlines.prospectus.document', {
                companyName,
                documentType,
            })}
        </span>
    )
}

export default NewsHeadlineProspectusMemorandum
